import type { FieldPolicy } from '@apollo/client'

import { mergePermissions } from '@broker-crm-utils/permissions'

// GraphQL User queries (GetCurrentUser, GetUser, etc.) return `permissions: []` by default —
// real permissions are populated separately by usePermissionResolution via cache.updateFragment.
// Without this merge, a User query that lands after the resolution silently wipes the populated
// array, forcing re-resolution and causing Apollo's "cache data may be lost" warning.
const permissions: FieldPolicy<ResolvedPermissionResolution[]> = {
  merge(existing = [], incoming = []) {
    if (!incoming.length) return existing
    if (!existing.length) return incoming
    return mergePermissions(existing, incoming)
  },
}

export default permissions
